import react from "react";

const Trade = () => {
  return (
    <>
      <div className="trade">
        <div className="wrapper">
          <div className="trade-content">
            <div className="heading content">
              <div
                className="sub-title"
                data-reveal="bottom"
                style={{
                  translate: "none",
                  rotate: "none",
                  scale: "none",
                  transform: "translate(0px)",
                  opacity: "1",
                  visibility: "inherit",
                }}
              >
                Trade Next
              </div>
              <h2
                className="h1"
                data-reveal="bottom"
                style={{
                  translate: "none",
                  rotate: "none",
                  scale: "none",
                  transform: "translate(0px)",
                  opacity: "1",
                  visibility: "inherit",
                }}
              >
                <small>
                  Buy <strong>$GEMAI</strong>
                </small>{" "}
                on Uniswap
              </h2>
              <div
                className="btn-group"
                data-reveal="bottom"
                style={{
                  translate: "none",
                  rotate: "none",
                  scale: "none",
                  transform: "translate(0px)",
                  opacity: "1",
                  visibility: "inherit",
                }}
              >
                <a
                  href="https://app.uniswap.org/swap?inputCurrency=0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2&amp;outputCurrency=0xFBE44caE91d7Df8382208fCdc1fE80E40FBc7e9a"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  data-colors="primary"
                >
                  <span className="btn-txt">Buy GEMAI</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    stroke="none"
                  >
                    <use href="/assets/sprites-JdJ7Xybh.svg#uniswap"></use>
                  </svg>
                  <div className="corner" data-colors="primary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </a>
                <a className="btn" data-colors="primary" href="/presale">
                  <span className="btn-txt">Join presale</span>
                  <div className="corner" data-colors="primary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </a>
              </div>
              <div className="point"></div>
            </div>
            <div className="logos">
              <div className="lazyload-wrapper ">
                <picture>
                  <img
                    src="/assets/uniswap-gemai-ojH3pXL9.png"
                    width="637"
                    height="397"
                    alt="Buy GemAI Token on Uniswap"
                    draggable="false"
                    loading="lazy"
                  />
                </picture>
              </div>
            </div>
            <div className="corner" data-colors="tertiary">
              <span className="corner-left"></span>
              <span className="corner-right"></span>
              <span className="corner-top-bottom"></span>
            </div>
            <div className="light"></div>
          </div>
          <div className="lazyload-wrapper ">
            <picture className="bck">
              <img
                src="/assets/bg-uniswap-Y8axSoJp.png"
                width="1800"
                height="937"
                alt="Trade"
                draggable="false"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
      </div>
    </>
  );
};

export default Trade;
